import { Space, Table, Tooltip } from 'antd';
import { DeleteActionSvg, EditActionSvg } from 'utils/svgs';
import styles from './index.module.scss';
import { useContext } from 'react';
import { PermissionContext } from 'components/Global/AuthLayout';
import dayjs from 'dayjs';
import { InfoCircleOutlined } from '@ant-design/icons';
import { invalidText } from 'utils/utils';
import Ellipse from 'components/Global/Ellipse';

const { Column } = Table;

type Props = {
	branchData: any;
	totalRecords: number;
	currentPage: number;
	pageSize: number;
	tableChangeHandler: (pagination: any, filter: any, sorter: any) => void;
	fetchRecords: any;
	setEditData: any;
	openDrawerHandler: any;
	setDrawerInfoHandler: any;
	showModal: any;
	isLoading: boolean;
	calculationMethod: any;
};

const BranchCodeTable = (props: Props) => {
	const {
		branchData,
		totalRecords,
		currentPage,
		pageSize,
		tableChangeHandler,
		openDrawerHandler,
		setDrawerInfoHandler,
		setEditData,
		showModal,
		isLoading,
		calculationMethod,
	} = props;

	const permissions = useContext(PermissionContext);
	// Edit user data handler
	const editDataHandler = (selectedObj: any) => {
		openDrawerHandler();
		setDrawerInfoHandler('Edit Branch Code');
		setEditData(selectedObj);
	};

	// Delete user data handler
	const deleteDataHandler = (userObject: any) => {
		setEditData(userObject);
		showModal();
	};
	return (
		<div className={styles['dynamic-table']}>
			<Table
				dataSource={branchData}
				scroll={{ y: 'calc(100vh - 360px)' }}
				pagination={{
					total: totalRecords,
					current: currentPage,
					pageSize: pageSize,
					showSizeChanger: false,
					// onShowSizeChange: pageSizeHandler,
					pageSizeOptions: [10, 20, 50, 100, 200],
				}}
				onChange={tableChangeHandler}
				rowKey={(record) => record.id}
				loading={isLoading}
			>
				<Column
					title="Code"
					dataIndex="code"
					key="code"
					sorter={true}
					className="bg-white"
					width={'15%'}
					render={(text, record: any) => {
						const isCalculationMonthMissing =
							calculationMethod === 'BRANCH_WISE' &&
							invalidText(record.calculationMonth);

						return (
							<Space>
								<Ellipse
									message={text}
									maxLength={20}
									key={text}
									tooltipMessage={text}
									isTooltip={true}
								/>
								{isCalculationMonthMissing && (
									<Tooltip title="Calculation month not configured">
										<InfoCircleOutlined
											style={{ color: '#544985' }}
										/>
									</Tooltip>
								)}
							</Space>
						);
					}}
				/>

				<Column
					title="Name"
					dataIndex="name"
					key="name"
					sorter={true}
					className="bg-white"
					width={'15%'}
					render={(text) => (
						<Ellipse
							message={text}
							maxLength={20}
							key={text}
							tooltipMessage={text}
							isTooltip={true}
						/>
					)}
				/>
				<Column
					title="Address"
					dataIndex="address"
					key="name"
					className="bg-white"
					sorter={true}
					width={'20%'}
					render={(text) => (
						<>
							{invalidText(text) ? (
								'-'
							) : (
								<Ellipse
									message={text}
									maxLength={20}
									key={text}
									tooltipMessage={text}
									isTooltip={true}
								/>
							)}
						</>
					)}
				/>
				<Column
					title="City"
					dataIndex="city"
					key="city"
					sorter={true}
					className="bg-white"
					width={'15%'}
					render={(text) => (
						<Ellipse
							message={text}
							maxLength={20}
							key={text}
							tooltipMessage={text}
							isTooltip={true}
						/>
					)}
				/>
				{calculationMethod === 'BRANCH_WISE' && (
					<Column
						width={'20%'}
						title={
							<span>
								<b>Calculation Month</b>{' '}
								<Tooltip title="Gratuity & Leave Pay applies at termination or scheduled branch month.">
									<InfoCircleOutlined
										style={{
											marginLeft: 4,
											color: '#584495',
										}}
									/>
								</Tooltip>
							</span>
						}
						dataIndex="calculationMonth"
						key="calculationMonth"
						className="bg-white"
						render={(value: any) => (
							<>
								{invalidText(value)
									? '-'
									: dayjs()
											.month(value - 1)
											.format('MMMM')}
							</>
						)}
					/>
				)}
				{(permissions.allowedPermissions.includes('Edit_Branch_Code') ||
					permissions.allowedPermissions.includes(
						'Delete_Branches'
					)) && (
					<Column
						title="Action"
						key="action"
						className="bg-white"
						width={'10%'}
						render={(_: any, data: any) => (
							<Space size={20}>
								{permissions.allowedPermissions.includes(
									'Edit_Branch_Code'
								) ? (
									<div
										className="cursor-pointer  flex align-center justify-center"
										onClick={() => editDataHandler(data)}
									>
										<EditActionSvg />
									</div>
								) : (
									<div className="cursor-not-allowed  flex align-center justify-center">
										<EditActionSvg color="#928F8F" />
									</div>
								)}
								{permissions.allowedPermissions.includes(
									'Delete_Branch_Code'
								) ? (
									<div
										className="cursor-pointer flex align-center justify-center"
										onClick={() => deleteDataHandler(data)}
									>
										<DeleteActionSvg />
									</div>
								) : (
									<div className="cursor-not-allowed flex align-center justify-center">
										<DeleteActionSvg color="#928F8F" />
									</div>
								)}
							</Space>
						)}
					/>
				)}
			</Table>
		</div>
	);
};

export default BranchCodeTable;
